import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TransactionService } from 'src/app/Services/transaction.service';

@Component({
  selector: 'app-spra-list',
  templateUrl: './spra-list.component.html',
  styleUrls: ['./spra-list.component.css']
})
export class SpraListComponent implements OnInit {

 
  public SpraListHeader: String[] = ["PartyName", "SaleType", "RequestNo", "RequestedDate", "RequestedBy"];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(
     public dialogRef: MatDialogRef<SpraListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
     private intl: MatPaginatorIntl,
     private changeDectector: ChangeDetectorRef,
     private _TransacionService: TransactionService,
    ) { 
      this.sort = new MatSort();
      this.paginator = new MatPaginator(this.intl, this.changeDectector);
    }

    ngOnInit(): void {
      this.GetSpraListByCompanyId();
      }
  
      ngAfterViewInit(): void {
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      }
    
  
      GetSpraListByCompanyId(){  
        if(this.data){
          this._TransacionService.GetSpraListByCompanyId(this.data.CompanyId,this.data.IsRental).subscribe((d:any)=>{
            if(d){
              this.dataSource = new MatTableDataSource(JSON.parse(d));
              setTimeout(() => {
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
              });
            }
            
          });
        }
        
      }
  
      OnSpraClick(Spra:any){
        this.dialogRef.close({data:Spra});
      }
    
      closeDialog(){
        this.dialogRef.close({event:'Cancel'});
      }

      public doFilter = (event: any) => {
        this.dataSource.filter = event.target.value.trim().toLocaleLowerCase();
      }

}
